<template>
  <Dialog dialog-classes="!max-w-md !p-14" :on-open="onOpen">
    <template #trigger>
      <div class="flex justify-center">
        <CanvaCtaButton :canva_cta_variant="canva_cta_variant" :image="props.image" />
      </div>
    </template>
    <template #content="{ closeDialog }">
      <div class="flex flex-col gap-y-6">
        <div class="text-center">
          <Heading level="h4" class="mb-2 max-w-[20ch]">{{ I18n.t("canva_cta.common.design_anything") }}</Heading>
          <p class="text-typo text-sm !m-0">{{ I18n.t("canva_cta.common.design_anything_description") }}</p>
        </div>
        <div class="max-w-[90%] grid grid-cols-3 gap-6 m-auto">
          <div v-for="(composition, index) in compositions" :key="index">
            <Card class="!p-0 flex relative">
              <ImageComposition :layers="composition" class="bg-shape" />
            </Card>
          </div>
        </div>
        <div class="flex flex-col gap-y-2">
          <Button full-width autofocus @click="handleClick(closeDialog)">{{ I18n.t("canva_cta.common.create") }}</Button>
          <p class="text-typo-secondary text-xs text-center mt-2 mb-1" v-html="tos_html"></p>
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import "@/src/i18n";
import { computed, inject } from "vue";
import { Button, Dialog, Heading, ImageComposition } from "prism";
import CanvaCtaButton from "./canva_cta_button.vue";
import { useCanvaLinkBuilder } from "../../composables/canva_link_builder";
import { rbgRedirectToCanvaClickedV100, rbgRedirectToCanvaConfirmedV100 } from "kaleido-event-tracker";

const flavor = document.querySelector("meta[property='canva-env']").getAttribute("content");
const { buildUrl } = useCanvaLinkBuilder(flavor);

const I18n = inject("I18n", window.I18n);
const tos_html = I18n.t("canva_cta.common.tos_link_html", { link: "https://www.canva.com/policies/terms-of-use/" });

const bgCta1 = "/images/canva-cta/bg_cta_1.jpg";
const bgCta2 = "/images/canva-cta/bg_cta_2.jpg";
const bgCta3 = "/images/canva-cta/bg_cta_3.jpg";

const props = defineProps({
  image: {
    type: String,
    required: true,
  },
  imageId: {
    type: String,
    required: true,
  },
  canva_cta_variant: {
    type: String,
    required: true,
  },
});

const url = buildUrl(props.image, "a");

const handleClick = (closeDialog) => {
  rbgRedirectToCanvaConfirmedV100({ image_id: props.imageId });
  window.open(url, "_blank");
  closeDialog();
};

const onOpen = () => {
  rbgRedirectToCanvaClickedV100({ image_id: props.imageId });
  reportSplit("canva_cta_variant");
};

const defaultBackgroundPlacement = {
  top: "0",
  left: "0",
  width: "100%",
  height: "auto",
  rotation: 0,
};

const defaultVariantAPlacement = {
  position: "absolute",
  rotation: 0,
  left: "50%",
  top: "50%",
  width: "auto",
  height: "auto",
  maxWidth: "72px",
  maxHeight: "72px",
};

const compositions = computed(() => [
  [
    {
      src: bgCta1,
      alt: "First background",
      placement: defaultBackgroundPlacement,
    },
    {
      src: props.image,
      alt: "Image with removed background",
      placement: {
        ...defaultVariantAPlacement,
      },
    },
  ],
  [
    {
      src: bgCta2,
      alt: "Second background",
      placement: defaultBackgroundPlacement,
    },
    {
      src: props.image,
      alt: "Image with removed background",
      placement: {
        ...defaultVariantAPlacement,
      },
    },
  ],
  [
    {
      src: bgCta3,
      alt: "Third background",
      placement: defaultBackgroundPlacement,
    },
    {
      src: props.image,
      alt: "Image with removed background",
      placement: {
        ...defaultVariantAPlacement,
      },
    },
  ],
]);
</script>
